import React from "react";
import { contactFacts } from "../../data/site";
export function ContactProcess() {
  return <section aria-labelledby="process-title" className="bg-white" data-id="element-164" data-mp="33qfi447vhbbz">
      <div className="page-container grid gap-8 py-16 md:py-24 lg:grid-cols-12 lg:gap-16" data-id="element-165" data-mp="33ss7v3jvgpzl">
        <div className="lg:col-span-4" data-id="element-166" data-mp="38s4rlffg5gxy">
          <h2 id="process-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-167" data-mp="3crvswd2lnfgq">
            What contacting the firm involves
          </h2>
        </div>
        <dl className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-168" data-mp="3hovx0ifw2857">
          {contactFacts.map(fact => <div key={fact.term} className="grid gap-1 py-6 sm:grid-cols-[15rem_1fr] sm:gap-8" data-id="element-169" data-mp="3rg01upbuocmb">
              <dt className="font-bold text-ink" data-id="element-170" data-mp="9yvuv6qs97j">{fact.term}</dt>
              <dd className="max-w-measure text-slate" data-id="element-171" data-mp="cbbv2sxw9hy">{fact.detail}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}